import { render, staticRenderFns } from "./podcastCard.vue?vue&type=template&id=0703e96e&scoped=true&"
import script from "./podcastCard.vue?vue&type=script&lang=js&"
export * from "./podcastCard.vue?vue&type=script&lang=js&"
import style0 from "./podcastCard.vue?vue&type=style&index=0&id=0703e96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0703e96e",
  null
  
)

export default component.exports